<template>
    <input id="datesFont">
</template>

<script>
    export default {
        mounted() {
             var self = this
             $('#datesFont').fontselect().change(function() {
             var datesFont = $(this).val().replace(/\+/g, ' ');
                 datesFont = datesFont.split(':');
                   self.$emit('get-font-dates', datesFont[0]);
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/JQueryPluggins/FontDates.vue